import React from 'react';
import '../styles.scss';
import { Assets } from '../../finder/components/Assets';
import { ClearPackButton } from './ClearPackButton';
import { Button } from '@myua/kit';
import { DocumentDownload } from '@myua/icons/dist/bulk16';
import { useDispatch, useSelector } from 'react-redux';
import { getData, getRelatedSharing } from '../selectors';
import filesize from 'filesize';
import { AppLayout } from '../../app/components/AppLayout';
import { SharePackButton } from '../../sharing/components/SharePackButton';
import { RoutedFullscreenPreview } from '../../fullscreenPreview/components/RoutedFullscreenPreview';
import { routes } from '../../router/model';
import * as packActions from '../actions';
import { getAssetLabLogger } from '../../app/logs';
import { PageTabs } from '../../app/components/PageTabs';
import { GoogleBulkMode } from '../../googleBulk/model';
import { GoogleBulkButton } from '../../googleBulk/components/GoogleBulkButton';
import { RelatedSharing } from './RelatedSharing';
import { DetailsToggleButton } from '../../finder/components/DetailsToggleButton';

export const PackPage = () => {
  const dispatch = useDispatch();
  const { total } = useSelector(getData);
  const assetLabLogger = useSelector(getAssetLabLogger);
  const relatedSharing = useSelector(getRelatedSharing);

  return (
    <AppLayout leftSider={false} rightSider={true}>
      <RoutedFullscreenPreview parentPath={routes.pack} />
      <div className="al-pack-page">
        <div className="al-pack-page-top">
          <div className="al-pack-page-top__left">
            <ClearPackButton />
            <Button
              type="primary"
              disabled={total.download.count === 0}
              icon={<DocumentDownload />}
              onClick={() => {
                dispatch(packActions.downloadPackClicked());
                assetLabLogger({ action: 'Pack', sub_action: 'Download' });
              }}
            >
              Download {total.download.count === 0 ? null : `(${filesize(total.download.size)})`}
            </Button>
            {relatedSharing ? null : <SharePackButton />}
            <GoogleBulkButton mode={GoogleBulkMode.pack} />
          </div>
          <PageTabs />
          <DetailsToggleButton />
        </div>

        <Assets header={<RelatedSharing />} />
      </div>
    </AppLayout>
  );
};
